import type { FC } from "react";
import { useMemo } from "react";

import type { ChipGroupItem } from "app/pages/sales-intelligence/common-components/filters-panel/components/ChipsGroup/ChipsGroup";
import ChipsGroup from "app/pages/sales-intelligence/common-components/filters-panel/components/ChipsGroup/ChipsGroup";

import type { IAppsAdSellersFilterItem } from "../../../types/commonFiltersDto";

type AdsSellersChipsGroupProps = {
    adsSellers: IAppsAdSellersFilterItem;
    onChange: (item: IAppsAdSellersFilterItem) => void;
};

const AdsSellersChipsGroup: FC<AdsSellersChipsGroupProps> = ({ adsSellers, onChange }) => {
    const handleOnChipDelete = (item: ChipGroupItem) => {
        const updatedAdsSellers = adsSellers.adsSellerDomainNames.filter((sdk: string) => sdk !== item.name);
        onChange({ ...adsSellers, adsSellerDomainNames: updatedAdsSellers });
    };

    const chipsData = useMemo(() => {
        return adsSellers?.adsSellerDomainNames?.map((adsSeller: string) => ({
            name: adsSeller,
            type: "ads-seller",
        }));
    }, [adsSellers]);

    return (
        <div>
            <ChipsGroup
                chipItems={chipsData}
                divider={adsSellers.operator}
                onDelete={handleOnChipDelete}
            />
        </div>
    );
};

export default AdsSellersChipsGroup;
